import { FieldValues, useFormContext } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { SPARKPOST } from '../../../../constants';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../../contexts';
import { useCreateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { createSparkpostPayload, getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { SparkpostEliteRadioLabel } from './SparkpostEliteRadioLabel';
import { GreyBorderedContainer } from '../../styles';

const { NAME, API_KEY, ESP, BINDING, API_ENDPOINT } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TEXT = {
  HEADER: 'Connect SparkPost account',
};

export const SparkpostCreateModal = () => {
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();
  const { hideModal } = useModalsContext();
  const { watch } = useFormContext();
  const { createAccount } = useCreateAccount();

  const accountType = watch(ESP);

  const espOptions = getEspRadioOptionsForSendingPlatform(SPARKPOST, espDefinitions).map(
    (option) =>
      option.id === SERVICE_PROVIDERS.SPARKPOST_ELITE
        ? { ...option, name: SparkpostEliteRadioLabel }
        : option,
  );

  const onSubmit = (values: FieldValues) => {
    const payload = createSparkpostPayload(values);
    createAccount(payload);
    hideModal();
  };

  return (
    <CreateModalRHF headerText={TEXT.HEADER} onSubmit={onSubmit}>
      <ConnectedInputField name={NAME} labelText="Name" />
      <AccountTypesRadioListField name={ESP} labelText="Account type" options={espOptions} />
      <GreyBorderedContainer>
        <ConnectedInputField name={API_KEY} labelText="API key" />
        <ConnectedInputField name={BINDING} labelText="IP Pool" />
        {accountType === SERVICE_PROVIDERS.SPARKPOST_ELITE && (
          <ConnectedInputField
            name={API_ENDPOINT}
            labelText="Custom endpoint URL"
            placeholder="Example: https://<domain>.sparkpost.com"
          />
        )}
      </GreyBorderedContainer>
    </CreateModalRHF>
  );
};
